const removeActive = (quickViewOptions) => {
  if (!quickViewOptions) {
    quickViewOptions = qsa('quick-view-options');
  }
  quickViewOptions.length > 0 && quickViewOptions.forEach(el=> {
    el.classList.remove('active');
    let quickViewBtn = qs('.quick-view-btn-js',el);
    quickViewBtn && quickViewBtn.classList.remove('hidden');
    let quickViewBody = qs('.quick-view-body',el);
    quickViewBody && quickViewBody.classList.add('hidden');
  })
}

class swatchCardProduct extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('swatch-card-product', swatchCardProduct);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.options = qsa('.option-value',this);
    this.prodCards = qsa('.card-wrapper.product-card-wrapper',this.closest('swatch-card-product'));
    this.clickEvent();
  }

  clickEvent = () => {
    this.options?.forEach((option) => {
      option.addEventListener('click',() => {
        let swatchCardProduct = option.closest('swatch-card-product');
        let quickViewOptions = qsa('quick-view-options',swatchCardProduct);
        removeActive(quickViewOptions);
        let color = option.dataset.color;
        this.prodCards.length > 0 && this.prodCards.forEach(card => {
          if (card.dataset.color === color) {
            let optionValue = qsa('.option-value',card);
            optionValue.length > 0 && optionValue.forEach((el) => {
              el.dataset.color === color ? el.classList.add('active') : el.classList.remove('active');
            });
            card.classList.remove('hidden');
          }else {
            card.classList.add('hidden');
          }
        })
      })
    });
  }
}

customElements.define('color-swatch', ColorSwatch);

class QuickViewOptions extends HTMLElement {
  constructor() {
    super();
    this.quickViewBtn = qs('.quick-view-btn-js',this);
    this.quickViewBody = qs('.quick-view-body',this);
    this.closeViewBody = qs('.close-view-body',this);
    this.addToCartBtn = qs('.form .product-form__submit',this);
    this.productVariantId = qs('.product-variant-id',this);
    this.optionInput = qsa('input',this);
    this.clickEvent();
  }

  clickEvent = () => {
    this.quickViewBtn && this.quickViewBtn.addEventListener('click',() => {
      removeActive();
      if (this.quickViewBtn.classList.contains('single-variant')) {
        this.addToCartBtn.click();
        return;
      }
      this.quickViewBtn.classList.add('loading');
      setTimeout(() => {
        this.quickViewBtn.classList.remove('loading');
        qs('.product-form',this).classList.remove('hidden');
        this.quickViewBtn.classList.add('hidden');
        this.quickViewBody.classList.remove('hidden');
        this.classList.add('active');

        if (window.innerWidth < 750) {
          let quickViewParent = this.closest('.product-card-wrapper');
        
          quickViewParent.closest('.product-card-wrapper').classList.add('open-swatch-popup');
          document.body.classList.add('open-swatch-popup-overflow-hidden');
        }

      }, 500);
    })
    
    this.optionInput.length > 0 && this.optionInput.forEach(input=> {
      input.checked = false;
      input.addEventListener('change',(e)=> {
        if (e.target.checked) {
          qs('.product-form',this).classList.remove('hidden');
          this.addToCartBtn.classList.remove('disabled');
          this.productVariantId.value = e.target.value;
          this.addToCartBtn.click();
        }
      })
    })

    this.closeViewBody && this.closeViewBody.addEventListener('click',() => {
      this.quickViewBody.classList.add('hidden');
      this.classList.remove('active');
      this.quickViewBtn.classList.remove('hidden');

      if (window.innerWidth < 750) {
        let quickViewParent = this.closest('.product-card-wrapper');
        quickViewParent.closest('.product-card-wrapper').classList.remove('open-swatch-popup');
        document.body.classList.remove('open-swatch-popup-overflow-hidden');
      }
    })
  }
}

customElements.define('quick-view-options', QuickViewOptions);



class CardProductSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.slider();
  }
  slider = () => {
    const swiperEl = this;
    // Remove a specific slide on larger screens
    if (window.innerWidth > 989) {
      swiperEl.querySelector('.remove-this-slide')?.remove();
    }
    // Initialize Swiper instance
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-product-next'),
        prevEl: swiperEl.querySelector('.swiper-product-prev')
      },
      scrollbar: {
        el: swiperEl.querySelector('.swiper-scrollbar')
      }
    });
  }
}
customElements.define('card-product-slider', CardProductSlider);